import { useEffect, useMemo } from "react";
import { getIn, useFormikContext } from "formik"
import {
  FormikDateSelector,
  FormikSelect,
  FormikNotesArea
} from "../../../../../../components/widgets"
import * as Yup from 'yup'
import { DLMAdminReviewSitesList, DLMAdminReviewSitesSchema } from "../components";
import { isPopulatedArray } from "../../../../../../components/helpers";
import { cloneDeep } from "lodash";
import { useUserLoader } from "../../../../../core/users";
import { IWebFileAttachment } from "../../../../../core/applications";

// Admin Review
export interface IDLMAdminReview1B3  {
  verdict: string
  appType: string
  note: string
  noteAttachments: Array<IWebFileAttachment>
  inspectionDate: string
  inspectorID: number
  sites: Array<any>
}

export const initDLMAdminReview1B3Values = {
  verdict: '',
  appType: '',
  note: '',
  noteAttachments: [],  
  inspectionDate: '',
  inspectorID: 0,
  sites: []
}

export const DLMAdminReview1B3Schema: any = Yup.object({
  verdict: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is: (val: string) => (val === 'rejected'),
    then: (schema) => schema.required(),
  }),
  noteAttachments: Yup.array(),  
  inspectionDate: Yup.string().trim().label('Inspection Date')
  .when('verdict', {
    is: (val: string) => (val === 'approved'),
    then: (schema) => schema.required(),
  }),
  inspectorID: Yup.number().integer().label('Inspector')
  .when('verdict', {
    is: (val: string) => (val === 'approved'),
    then: (schema) => schema.required().moreThan(0,'Select Site Inspector'),
  }),
  sites: Yup.array().of(DLMAdminReviewSitesSchema) 
  .when('verdict', {
    is: (val: string) => (val === 'approved'),
    then: (schema) => schema.required().min(1,'Sites Required'),
  }),
});

export const DLMAdminReview1B3Form = ( {siteROIModels} : {siteROIModels: any}) => {

  const { values, setFieldValue } = useFormikContext();

  const verdict = useMemo(() => {
    return getIn(values, 'verdict');
  }, [values]);

  const { data: inspectors } = useUserLoader({userType: 'DLM Inspector'});
  
  useEffect(() => {
    const sites = getIn(values, 'sites');

    if (verdict !== 'approved') {
      setFieldValue('sites', []);
    } else if (! isPopulatedArray(sites)) {
      setFieldValue('sites', cloneDeep(siteROIModels));
    }
  // eslint-disable-next-line
  }, [verdict]);

  return (
  <>
  { (verdict === 'approved') &&
  <>
  <h4>Component Check</h4>
  <div className="row mb-2">
    <FormikSelect size="6" label="Assign Inspector" name="inspectorID" required={true} options={inspectors} placeholder='Select Inspector' />
    <FormikDateSelector size="6" label="Inspection Date" name="inspectionDate" required={true} showShiftSelector={true} dateFormat='LL' asRow />
  </div>
  <h4>Inspection Setup</h4>
  <div className="row mb-2">
    <DLMAdminReviewSitesList />
  </div>
  </>
  } 
  <div className='separator border-gray-200 my-2'></div>
  <FormikNotesArea required={verdict === 'rejected'} />
  </>
  )
}